/*
 * persistedActionsReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 19-Jun-2025
 */

import { produce } from 'immer'
import { actionTypes } from 'Store/actions/persistedActions'

const initialState = {
  persisted: {} // structure: { [actionType]: payload }
}

const ACTION_HANDLERS = {
  [actionTypes.STORE_PERSISTED_ACTION]: produce((draft, action) => {
    const { type, payload } = action.payload
    draft.persisted[type] = payload
  }),

  [actionTypes.CLEAR_PERSISTED_ACTIONS]: produce((draft) => {
    draft.persisted = {}
  })
  // @generator reducer:type:action
}

const persistedActionsReducer = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default persistedActionsReducer
